// src/modules/settings/settingsService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getToken = () => {
  return localStorage.getItem('token');
};
const token = getToken();


export const getSettings = async () => {
  
  const response = await axios.get(`${API_URL}/settings`, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
  return response.data;
};

export const getSetting = async (id) => {
  const response = await axios.get(`${API_URL}/settings/${id}`, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
  return response.data;
};

export const createSetting = async (setting) => {
  const response = await axios.post(`${API_URL}/settings`, setting, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
  return response.data;
};

export const updateSetting = async (id, setting) => {
  const response = await axios.put(`${API_URL}/settings/${id}`, setting, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
  return response.data;
};

export const deleteSetting = async (id) => {
  const response = await axios.delete(`${API_URL}/settings/${id}`, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
  return response.data;
};
